// src/firebase.ts
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyAHVejlmqDOg3TI_vI1D9pQxrPFg2N2LsI",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "refurb-buy.firebaseapp.com",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "refurb-buy",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "refurb-buy.firebasestorage.app",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "805811961724",
  appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:805811961724:web:9725ff9df1797894c76ef9",
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "G-HX8H030GRG"
};
 
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);